/*
 * @Descripttion:
 * @Date: 2024-04-07 09:16:04
 */
import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useRouter } from 'vue-router';
import type { EntpAuthInfoInt } from '../data-source/types';
import { entpAuthInfo as entpAuthInfoApi } from '../data-source/apis';
import { AuthStepMapping } from '../constants/index';

const createState = (): EntpAuthInfoInt => {
  return {
    entpName: '',
    entityType: null,
    entpCertPic: '',
    entpCertType: null,
    entpCertNo: '',
    contactor: '',
    contactId: '',
    contactorPhone: null,
    authStep: null,
    authStatus: null,
    deptId: null,
    auditStatus: null,
    protocolCheck: null,
    auditReason: '',
    legalName: ''
  };
};
export const useEnterpriseRealStoreSetup = defineStore(
  'useEnterpriseRealStoreSetup',
  () => {
    const router = useRouter();
    const entpAuthInfo = ref(createState());

    /**
     * @description: 获取企业实名信息
     * @returns {*}
     */
    const getEntpAuthInfo = async (cb?: (a: EntpAuthInfoInt) => void) => {
      try {
        const res = await entpAuthInfoApi();
        entpAuthInfo.value = res.data;
        cb && typeof cb === 'function' && cb(res.data);
        return res.data;
      } catch (error) {
        console.log(error);
      }
    };

    /**
     * @description: 根据后端返回的步数跳转到对应页面
     * @param {*} authStep
     * @returns {*}
     */
    const skipNextPage = (authStep, skipType = 'push') => {
      if (!authStep) return;

      const nextPage = AuthStepMapping[authStep];
      router[skipType]({
        name: nextPage.name,
        query: nextPage.query
      });
    };

    // 向日葵服务平台用户协议勾选状态
    const agreementChecked = ref(0);
    // 企业信息-确认弹框状态
    const showConfirmDialog = ref(true);

    return {
      entpAuthInfo,
      getEntpAuthInfo,
      skipNextPage,
      agreementChecked,
      showConfirmDialog
    };
  },
  {
    persist: {
      storage: sessionStorage
    }
  }
);
